export const NakdanType = {
  Pro: process.env.VUE_APP_TYPE_OF_MULTI_NAKDAN === 'pro',
  Simple: process.env.VUE_APP_TYPE_OF_MULTI_NAKDAN === 'simple',
  SavedStateName: process.env.VUE_APP_TYPE_OF_MULTI_NAKDAN + '-nakdan-saved-state'
}

export const SimpleVsProConfig = {
  IMPLEMENT_USER_ACCOUNTS: NakdanType.Pro,
  PRE_SUBMISSION_OPTIONS_TO_PROVIDE: {
    ONLY_GENRE: NakdanType.Simple,
    ALL: NakdanType.Pro
  },
  HOW_TO_USE_OPENS: {
    POPUP: NakdanType.Simple,
    DOCUMENTATION_TAB: NakdanType.Pro    
  },
  USE_MULTIPLE_NIKUD_KEYBOARDS: NakdanType.Pro,
  USE_LETTER_ADDING_MODE: NakdanType.Pro,
  SHOW_KEYBOARD_DISPLAYS: NakdanType.Pro, // partly b/c w/o multiple kbds there's nowhere to show, partly b/c nonpros won't care
  NO_KEYBOARD_NIKUD_AT_ALL: NakdanType.Simple,
  NAVIGATION_KEYS_FOR_WORDS_ONLY: NakdanType.Simple,
  NIKUD_BUTTONS: {
    SHOW_BY_DEFAULT: NakdanType.Simple,
    CAN_SHOW_OR_HIDE: NakdanType.Pro
  },
  EDIT_NIKUD_POPUP: {
    ENABLE: NakdanType.Pro,
    PRESENT: NakdanType.Pro
  },
  NIKUD_PANES: {
    START_OPEN: NakdanType.Pro,
    USE_WELCOME: NakdanType.Simple
  },
  USE_WELCOME_POPUP: NakdanType.Pro,
  MAIN_RESULTS_WINDOW: {
    USE_LETTER_CURSOR: NakdanType.Pro,
    SHOW_LINE_BREAK_CHAR: NakdanType.Pro,
    CAN_CLICK_ON_LETTERS: NakdanType.Pro,
    START_BY_SINGLE_CLICK: NakdanType.Simple,
    START_BY_DOUBLE_CLICK: false
  },
  EXPORT_AIMS: {
    USER_CONTROLLED: NakdanType.Pro,
    FOLLOW_DISPLAY: NakdanType.Simple
  },
  IMPLEMENT_QAMATZ_QATAN: NakdanType.Pro
}
